import { createSelector } from 'reselect';
import { scienceOccupationsSelector } from 'selectors';
import { extractDatesFromNestedItems } from 'utils';

export const scienceOccupationsYearsSelector = createSelector([scienceOccupationsSelector], (scienceOccupations) =>
  extractDatesFromNestedItems(
    [scienceOccupations.content],
    [
      {
        type: 'range',
        startField: 'startDate',
        endField: 'endDate',
      },
    ],
  ),
);
